import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";

const BookingSection = () => {
  const { t, i18n } = useTranslation();
  const languageDirection = i18n.language === "ar" ? "rtl" : "ltr";

  // تهيئة AOS عند تحميل المكون
  useEffect(() => {
    AOS.init({
      duration: 1000, 
      once: true,     
    });
  }, []);

  return (
    <section
      dir={languageDirection}
      className="py-5 mt-5"
      style={{
        background: "linear-gradient(rgba(107, 114, 224, 0.05), rgba(107, 114, 224, 0.1))",
      }}
    >
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-10 text-center" data-aos="fade-up">
            <div className="card border-0 shadow-lg p-4">
              <div className="card-body py-5">
                <div
                  className="d-inline-flex justify-content-center align-items-center bg-primary-custom rounded-circle mb-3"
                  style={{ width: "70px", height: "70px" }}
                  data-aos="zoom-in"
                  data-aos-delay="200"
                >
                  <i className="fas fa-calendar-check fa-2x text-white"></i>
                </div>
                <h2
                  className="fw-bold text-primary-custom mb-3"
                  data-aos="fade-up"
                  data-aos-delay="400"
                >
                  {t("needASpeaker")}
                </h2>
                <p
                  className="lead text-muted mb-4"
                  data-aos="fade-up"
                  data-aos-delay="600"
                >
                  {t("professionalSpeakers")}
                </p>
                <a
                  href="/contact"
                  className="btn btn-outline-primary btn-lg px-5 py-3"
                  data-aos="fade-up"
                  data-aos-delay="800"
                >
                  <i className="fas fa-calendar-plus me-2"></i>
                  {t("bookSpeakerNow")}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookingSection;
